goog.provide('el8.print.scheduleReport');

goog.require('el8.appservice.status');
goog.require('el8.data.init');
goog.require('el8.data.physicians');
goog.require('el8.data.practices');
goog.require('el8.data.practiceSettings');
goog.require('el8.practicedata.appts');
goog.require('el8.practicedata.model.appt');
goog.require('el8.ptdata.patients');
goog.require('el8.service.tz');
goog.require('el8.template.print.scheduleReport');
goog.require('el8.util.print');


el8.print.scheduleReport.init = function(spec) {
    el8.appservice.status.init();

    if (spec.data) { el8.data.init(spec.data); }

    // group appts by apptDateString e.g. '01/01/2016'
    var apptsByDate = _.chain(el8.practicedata.appts.create(spec.appts))
                       .filter(function(a) { return !a.isTimeBlock(); })
                       .map(function(a) {
                          return a.asSoyMap();
                       })
                       .groupBy(function(aMap) {
                           return aMap.apptDateString;
                       })
                       .value();

    var grandTotal = _.chain(el8.practicedata.appts.all())
                      .filter(function(a) { return a.getCopayCollected(); })
                      .map(function(a) {
                        return parseFloat(a.getCopayCollected().getAmount());
                      })
                      .reduce(function(memo, value, index) {
                        return memo + value;
                      }, 0)
                      .value();

    var _totals = _.map(apptsByDate, function(appts) {
                                return  _.chain(appts)
                                         .filter(function(a) { return a.copayCollected; })
                                         .map(function(a) { return parseFloat(a.copayCollected.amount); })
                                         .reduce(function(memo, value, index) { return memo + value; }, 0)
                                         .value();

                  });

    // create an index of totals by date from the apptsByDate keys
    var totalsByDate = {};
    _.each(_.keys(apptsByDate), function(date, i) {
      totalsByDate[date] = _totals[i].toFixed(2);
    });

    $('.print-content').replaceWith(
        el8.template.print.scheduleReport.content({
            practice: el8.data.practices.create(spec.practice).asSoyMap(),
            physician: spec.physician ? el8.data.physicians.create(spec.physician).asSoyMap(): null,
            startDate: spec.startDate,
            endDate: spec.endDate,
            dates: _.keys(apptsByDate), // array to iterate over
            apptsByDate: apptsByDate,
            nAppts: spec.appts ? spec.appts.length: 0,
            now: el8.service.tz.asServerFormatDateTime(el8.service.tz.now()),
            hasCopay: _.any(spec.appts, function(appt) { return !!appt.copay_collected; }),
            grandTotal: grandTotal.toFixed(2),
            totalsByDate: totalsByDate
        })
    );

    el8.util.print.pageSetup();
};
